import * as FormatOptions from './DateTimeFormatOptions';
import {UniFocusEnvironment} from '../../environment/Environment';
import DateTimeFormatOptions = Intl.DateTimeFormatOptions;

const formatterWithOptions = (locale: string, dateTimeFormatOptions: DateTimeFormatOptions): Intl.DateTimeFormat => {
   return new Intl.DateTimeFormat(locale, dateTimeFormatOptions);
};

export const dateFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.dateFormatOptions(environment));
};

export const dateYearLongFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.dateYearLongFormatOptions(environment));
};

export const dateMediumFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.dateMediumFormatOptions(environment));
};

export const dateLongFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.dateLongFormatOptions(environment));
};

export const dateFullFormatter = (environment: UniFocusEnvironment,
                                  shortWeekday: boolean,
                                  shortMonth: boolean): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.dateFullFormatOptions(environment, shortWeekday, shortMonth));
};

export const dateCellFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.dateCellFormatOptions(environment));
};

export const dateWithDowFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.dateWithDowFormatOptions(environment));
};

export const dateTimeFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.dateTimeFormatOptions(environment));
};

export const timeFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.timeFormatOptions(environment));
};

export const timeFormatterWithSeconds = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.timeFormatWithSecondsOptions(environment));
};

export const hourFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.hourFormatOptions(environment));
};

export const weekdayNarrowFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.weekdayNarrowFormatOptions(environment));
};

export const weekdayShortFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.weekdayShortFormatOptions(environment));
};

export const weekdayLongFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.weekdayLongFormatOptions(environment));
};
export const monthDayFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.monthDayFormatOptions(environment));
};

export const monthYearFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.monthYearFormatOptions(environment));
};

export const monthShortFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.monthShortFormatOptions(environment));
};

export const monthLongFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.monthLongFormatOptions(environment));
};

export const yearLongFormatter = (environment: UniFocusEnvironment): Intl.DateTimeFormat => {
   return formatterWithOptions(environment.locale, FormatOptions.yearLongFormatOptions(environment));
};
